import { render, staticRenderFns } from "./HeaderSetting.vue?vue&type=template&id=014befe8&scoped=true&"
var script = {}
import style0 from "./HeaderSetting.vue?vue&type=style&index=0&id=014befe8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014befe8",
  null
  
)

export default component.exports